var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button-primary",attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.emitClick($event)}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('div',{staticClass:"spinner is-active"}),_vm._v(" "),_c('p',{staticClass:"screen-reader-text"},[_vm._v("Button for form disabled until request has processed.")])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./admin/src/js/components/AcButton.vue?vue&type=template&id=49708487
// module id = 20
// module chunks = 0